import { Location, NgPlural, NgPluralCase } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { User } from 'src/app/models/data/user';
import {
	AssignUserRoleRequestStatus,
	AssignUserRoleRequestStatusEvent,
} from 'src/app/ui/roles/role-detail/role-detail-add-user/role-detail-add-user-main-tab.component';
import { MatDivider } from '@angular/material/list';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-role-detail-confirmation',
	templateUrl: './role-detail-confirmation.component.html',
	styleUrls: [
		'./role-detail-confirmation.component.scss',
		'../../../common/main.scss',
	],
	imports: [MatDivider, MatProgressSpinner, MatButton, NgPlural, NgPluralCase],
})
export class RoleDetailConfirmationComponent implements OnInit {
	@Input()
	createRoleRequestStatusEvent!: Observable<AssignUserRoleRequestStatusEvent>;
	@Input() companyId?: string;
	@Input() isActiveCompany = false;
	@Input() roleId!: string;
	showLoading = false;
	showSuccess = false;
	showFailure = false;
	users: User[] = [];
	roleName = '';

	constructor(
		private readonly router: Router,
		private location: Location
	) {}

	ngOnInit(): void {
		this.createRoleRequestStatusEvent.subscribe((event) => {
			this.showLoading = false;
			this.showSuccess = false;
			this.showFailure = false;

			this.roleName = event?.data?.roleName ?? '';
			this.users = event?.data?.users ?? [];

			switch (event.status) {
				case AssignUserRoleRequestStatus.loading:
					this.showLoading = true;
					break;
				case AssignUserRoleRequestStatus.success:
					this.showSuccess = true;
					break;
				case AssignUserRoleRequestStatus.failure:
					this.showFailure = true;
					break;
			}
		});
	}

	returnToRoles(): void {
		if (!this.isActiveCompany && this.companyId) {
			this.router.navigateByUrl(
				`/company/${this.companyId}/detail/role/${this.roleId}/detail`
			);
		} else {
			this.router.navigateByUrl(`/roleDetail/${this.roleId}`);
		}
	}
}
